import { LOCALE_ID, Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';

import { NotifyService } from '@fry/lib/utils';

import { UserLanguage, UserLanguageService } from '../user-language/user-language.service';
import { User, UsersStore } from '@fry/lib/users';


@Component({
    selector: 'eas-user-language-edit',
    templateUrl: './user-language-edit.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserLanguageEditComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  availableLanguages: UserLanguage[];
  form: UntypedFormGroup;
  user$: Observable<User>;

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<UserLanguageEditComponent>,
    private notify: NotifyService,
    private userLanguageService: UserLanguageService,
    private users: UsersStore,
    @Inject(MAT_DIALOG_DATA) private data: { user: User },
  ) {
    this.form = this.fb.group(
    { languageCode: [null] }
    );
  }

  ngOnInit() {
    this.availableLanguages = this.userLanguageService.availableLanguages;

    const language = this.userLanguageService.getPreferredLanguage(this.data.user);
    this.form.controls['languageCode'].setValue(language.languageCode);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onSubmit() {
    const localeNew = this.form.controls['languageCode'].value;
    this.users.updateLanguage(this.data.user, localeNew).subscribe(
      profile => {
        this.dialogRef.close(profile);
      },
      error => this.notify.error(error)
    );
  }

  onCancel() {
    this.dialogRef.close();
  }
}
